<app-header></app-header>

<body>
    <div class="container my-5">
        <form #productForm="ngForm" (ngSubmit)="submit(productForm)">
            <div class="form-group">
                <label for="Name">Name</label>
                <input type="text" name="Name" id="name" [(ngModel)]="name" class="form-control">
            </div>
            <div class="form-group">
                <label for="Description">Description</label>
                <input type="text" name="Description" id="Description" [(ngModel)]="Description" class="form-control">
            </div>
            <div class="form-group">
                <label for="iconLink">Icon Link</label>
                <input type="text" name="iconLink" id="iconLink" [(ngModel)]="icon" class="form-control">
            </div>
            <div class="form-group">
                <label for="DownloadLink">Download Link</label>
                <input type="text" name="DownloadLink" id="DownloadLink" [(ngModel)]="DownloadLink" class="form-control">
            </div>
            <div class="form-group">
                <label for="Screenshot">Screen Shot</label>
                <input type="text" name="Screenshot" id="Screenshot" [(ngModel)]="Screenshot" class="form-control">
            </div>
            <div class="form-group">
                <label for="Features">Features</label>
                <input type="text" name="Features" id="Features" [(ngModel)]="Features" class="form-control">
            </div>
            <div class="form-group">
                <label for="version">version</label>
                <input type="text" name="version" id="version" [(ngModel)]="version" class="form-control">
            </div>
            <div class="form-group">
                <label for="AppType">AppType</label>
                <input type="text" name="AppType" id="AppType" [(ngModel)]="AppType" class="form-control">
            </div>
            <div class="form-group">
                <label for="New">New</label>
                <input type="text" name="New" id="New" [(ngModel)]="New" class="form-control">
            </div>
            <div class="form-group">
                <label for="privacyPolicyURL">privacyPolicyURL</label>
                <input type="text" name="privacyPolicyURL" id="privacyPolicyURL" [(ngModel)]="privacyPolicyURL" class="form-control">
            </div>
            <div class="form-group">
                <label for="AppSize">AppSize</label>
                <input type="text" name="AppSize" id="AppSize" [(ngModel)]="AppSize" class="form-control">
            </div>
            <input type="submit" value="Add new" class="btn btn-primary mt-3">
        </form>
    </div>

</body>
<app-footer></app-footer>